import type { HTMLAttributes } from 'react';

import { cn } from '#/lib/utils';

type Props = {
  /** Raw SVG markup, e.g. the `svg` string stored on a Sanity icon. */
  svg?: string | null;
  className?: string;
} & Omit<
  HTMLAttributes<HTMLSpanElement>,
  'dangerouslySetInnerHTML' | 'children'
>;

/**
 * Renders an inline SVG string (as stored in Sanity via the inline-svg input).
 * The SVG uses `currentColor`, so set the color and size through `className`
 * (e.g. `text-electric [&_svg]:size-40`).
 */
export function SvgIcon({ svg, className, ...rest }: Props) {
  if (!svg) return null;

  return (
    <span
      className={cn('inline-flex', className)}
      dangerouslySetInnerHTML={{ __html: svg }}
      {...rest}
    />
  );
}
